import { Badge } from '@/components/ui/badge'
import { Typography } from '@/components/ui/typography'
import type { RefundedOrderItem } from '@/lib/services/carts/carts.types'
import { formatCurrency } from '@/lib/utils'

type RefundedOrderItemRowProps = {
  item: RefundedOrderItem
}

/** An order item a refund already settled: it stays on the order as the refund left it, and a change leaves it alone. */
export function RefundedOrderItemRow({ item }: RefundedOrderItemRowProps) {
  return (
    <div className="@container border-b p-2 last:border-b-0">
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <Typography variant="label" tone="muted" className="line-clamp-2">
            {item.name ?? 'Item'}
          </Typography>
          <div className="flex min-w-0 items-center gap-1.5">
            <Badge variant="secondary" size="xs">
              Refunded
            </Badge>
            {item.quantity !== 1 ? (
              <Typography variant="label" tone="muted">
                {`Qty ${item.quantity}`}
              </Typography>
            ) : null}
            <Typography variant="label" tone="muted">
              Kept as refunded
            </Typography>
          </div>
        </div>
        <Typography variant="label" tone="muted" className="shrink-0 tabular-nums">
          {formatCurrency(item.amount)}
        </Typography>
      </div>
    </div>
  )
}
